// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Font import */
/* @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300..700&display=swap'); */

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* Max width for app until desktop version is made. */
  max-width: 768px;
  margin: 0 auto;

  /* Variables */

  /* Basic colors */
  --white: #ffffff;
  --black: #000000;
  --light-grey: #DDDDDD;
  --dark-grey: #767676;
  --red: #E57373;
  --green: #0F9D58;
  --gold: #CCA34F;
  
  /* Old colors */
  --light-purple: #E3DBED;
  --orange: #FF5C00;
  --offwhite: #EBD9BA;
  --purple: #CDA5FF;

  /* New colors */
  --link-blue: #045caa;
  --dark-blue: #167C7E;
  --light-blue: #A8E6CE; 

  --shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.25);
}

/* Images */
.c-image--fit {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  object-fit: cover;
  border-radius: var(--border-radius);
}

.c-image__dim:after {
  content: " ";
  z-index: 1;
  display: block;
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: var(--border-radius);
}

/*
** Utilities
*/

.u-display-flex {
  display: flex;
}

.u-display-block {
  display: block;
}

.u-display-none {
  display: none;
}

.u-gap-8 {
  gap: 8px;
}

.u-position-relative {
  position: relative;
}

.u-position-absolute {
  position: absolute;
}

.u-line-break {
  white-space: pre-wrap;
}

.u-align-items-center {
  align-items: center;
}

.u-align-items-end {
  align-items: end;
}

.u-justify-content-center {
  justify-content: center;
}

.u-justify-content-space-between {
  justify-content: space-between;
}

.u-font-weight-bold {
  font-weight: bold;
}

.u-font-weight-semi-bold {
  font-weight: 500;
}

.u-font-weight-normal {
  font-weight: 400;
}

.u-flex-direction-column {
  flex-direction: column;
}

.u-text-align-center {
  text-align: center;
}

.u-text-decoration-dotted {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

.u-text-decoration-underline {
  text-decoration: underline;
}

.u-margin-0 {
  margin: 0;
}

.u-margin-right-4 {
  margin-right: 4px;
}

.u-margin-right-8 {
  margin-right: 8px;
}

.u-margin-0-auto {
  margin: 0 auto;
}

.u-margin-x-4 {
  margin-left: 4px;
  margin-right: 4px;
}

.u-margin-y-0 {
  margin-top: 0;
  margin-bottom: 0;
}

.u-margin-y-8 {
  margin: 8px 0;
}

.u-margin-y-16 {
  margin: 16px 0;
}

.u-margin-y-32 {
  margin: 32px 0;
}

.u-margin-top-0 {
  margin-top: 0;
}

.u-margin-top-16 {
  margin-top: 16px;
}

.u-margin-bottom-0 {
  margin-bottom: 0;
}

.u-margin-bottom-4 {
  margin-bottom: 4px;
}

.u-margin-bottom-8 {
  margin-bottom: 8px;
}

.u-margin-bottom-16 {
  margin-bottom: 16px;
}

.u-margin-bottom-24 {
  margin-bottom: 24px;
}

.u-margin-bottom-32 {
  margin-bottom: 32px;
}

.u-padding-y-16 {
  padding: 16px 0;
}

.u-padding-x-16 {
  padding: 0 16px;
}

.u-padding-16 {
  padding: 16px;
}

.u-padding-top-32 {
  padding-top: 32px;
}

.u-padding-top-24 {
  padding-top: 24px;
}

.u-padding-x-24 {
  padding: 0 24px
}

.u-font-size-8 {
  font-size: 8px;
}

.u-font-size-12 {
  font-size: 12px;
}

.u-font-size-14 {
  font-size: 14px;
}

.u-font-size-16 {
  font-size: 16px;
}

.u-font-size-20 {
  font-size: 20px;
}

.u-font-size-24 {
  font-size: 24px;
}

.u-font-size-32 {
  font-size: 32px;
}

.u-opacity-0 {
  opacity: 0;
}

.u-white-space-nowrap {
  white-space: nowrap;
}

/* Font Colors */
.u-color-white {
  color: var(--white);
}

.u-color-black {
  color: var(--black);
}

.u-color-green {
  color: var(--green);
}

.u-color-red {
  color: var(--red);
}

.u-color-light-grey {
  color: var(--light-grey);
}

.u-color-dark-grey {
  color: var(--dark-grey);
}

.u-color-offwhite {
  color: var(--offwhite);
}

.u-fill-white {
  fill: var(--white);
}

.u-fill-black {
  fill: var(--black);
}

.u-fill-gold {
  fill: var(--gold);
}

.u-background-none {
  background: none;
}

.u-border-none {
  border: none;
}

.h3 {
  text-align: left;
  margin-top: 0;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 16px;
}

/* 
 * Utility class to hide content visually while keeping it screen reader-accessible.
 * Source: https://www.scottohara.me/blog/2017/04/14/inclusively-hidden.html 
 */

 .u-visually-hidden:not(:focus):not(:active) {
  clip: rect(0 0 0 0); 
  clipPath: inset(100%); 
  height: 1px; 
  overflow: hidden; 
  position: absolute; 
  white-space: nowrap; 
  width: 1px; 
}

/* Component Styles */
.c-plain-link {
  text-decoration: none;
}

.c-clamp {
  -webkit-line-clamp: 25;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  mask-image: linear-gradient(to bottom, black 90%, transparent 100%);
}

.c-swing {
  animation: swing ease-in-out 1s 3.5 alternate;
  transform-origin: center -20px;
  box-shadow: 5px 5px 10px rgba(0,0,0,0.5);
  border-radius: var(--border-radius);
  position: relative;
}

.c-swing img {
  border-radius: var(--border-radius);
  border: 5px solid var(--gold);
  display: block;
  box-shadow: var(--shadow);
}

.c-swing:after{
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid var(--black);
  top: -9px;
  left: 43%;
  z-index: 0;
  border-bottom: none;
  border-right: none;
  transform: rotate(45deg);
}

.c-swing:before{
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  top: -17px;
  left: 47%;
  z-index: 5;
  border-radius: 50% 50%;
  background: linear-gradient(90deg, rgba(204, 163, 79, 1) 0%, rgba(152, 117, 46, 1) 100%);
}

@keyframes swing {
  0% { transform: rotate(3deg); }
  100% { transform: rotate(-3deg); }
}

/* Alice Carousel */
.c-slider .alice-carousel__prev-btn,
.c-slider .alice-carousel__next-btn {
  width: unset;
  padding: unset;
  position: absolute;
  top: 45%;
  box-shadow: var(--shadow);
  background-color: var(--white);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.c-slider .alice-carousel__dots {
  margin-top: 0;
}

.c-slider .alice-carousel__prev-btn-item,
.c-slider .alice-carousel__next-btn-item {
  color: black;
}

.c-container {
  margin: 0 20px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,sGAAsG;;AAEtG;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;;EAElC,qDAAqD;EACrD,gBAAgB;EAChB,cAAc;;EAEd,cAAc;;EAEd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;;EAEf,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;;EAEjB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;;EAErB,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;;CAEC;;AAED;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE;;CAED;EACC,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,mEAAmE;AACrE;;AAEA;EACE,6CAA6C;EAC7C,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,SAAS;EACT,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,wFAAwF;AAC1F;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,wBAAwB,EAAE;AACnC;;AAEA,mBAAmB;AACnB;;EAEE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Font import */\n/* @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300..700&display=swap'); */\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  /* Max width for app until desktop version is made. */\n  max-width: 768px;\n  margin: 0 auto;\n\n  /* Variables */\n\n  /* Basic colors */\n  --white: #ffffff;\n  --black: #000000;\n  --light-grey: #DDDDDD;\n  --dark-grey: #767676;\n  --red: #E57373;\n  --green: #0F9D58;\n  --gold: #CCA34F;\n  \n  /* Old colors */\n  --light-purple: #E3DBED;\n  --orange: #FF5C00;\n  --offwhite: #EBD9BA;\n  --purple: #CDA5FF;\n\n  /* New colors */\n  --link-blue: #045caa;\n  --dark-blue: #167C7E;\n  --light-blue: #A8E6CE; \n\n  --shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.25);\n}\n\n/* Images */\n.c-image--fit {\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  object-fit: cover;\n  border-radius: var(--border-radius);\n}\n\n.c-image__dim:after {\n  content: \" \";\n  z-index: 1;\n  display: block;\n  position: absolute;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: var(--border-radius);\n}\n\n/*\n** Utilities\n*/\n\n.u-display-flex {\n  display: flex;\n}\n\n.u-display-block {\n  display: block;\n}\n\n.u-display-none {\n  display: none;\n}\n\n.u-gap-8 {\n  gap: 8px;\n}\n\n.u-position-relative {\n  position: relative;\n}\n\n.u-position-absolute {\n  position: absolute;\n}\n\n.u-line-break {\n  white-space: pre-wrap;\n}\n\n.u-align-items-center {\n  align-items: center;\n}\n\n.u-align-items-end {\n  align-items: end;\n}\n\n.u-justify-content-center {\n  justify-content: center;\n}\n\n.u-justify-content-space-between {\n  justify-content: space-between;\n}\n\n.u-font-weight-bold {\n  font-weight: bold;\n}\n\n.u-font-weight-semi-bold {\n  font-weight: 500;\n}\n\n.u-font-weight-normal {\n  font-weight: 400;\n}\n\n.u-flex-direction-column {\n  flex-direction: column;\n}\n\n.u-text-align-center {\n  text-align: center;\n}\n\n.u-text-decoration-dotted {\n  text-decoration: underline dotted;\n}\n\n.u-text-decoration-underline {\n  text-decoration: underline;\n}\n\n.u-margin-0 {\n  margin: 0;\n}\n\n.u-margin-right-4 {\n  margin-right: 4px;\n}\n\n.u-margin-right-8 {\n  margin-right: 8px;\n}\n\n.u-margin-0-auto {\n  margin: 0 auto;\n}\n\n.u-margin-x-4 {\n  margin-left: 4px;\n  margin-right: 4px;\n}\n\n.u-margin-y-0 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.u-margin-y-8 {\n  margin: 8px 0;\n}\n\n.u-margin-y-16 {\n  margin: 16px 0;\n}\n\n.u-margin-y-32 {\n  margin: 32px 0;\n}\n\n.u-margin-top-0 {\n  margin-top: 0;\n}\n\n.u-margin-top-16 {\n  margin-top: 16px;\n}\n\n.u-margin-bottom-0 {\n  margin-bottom: 0;\n}\n\n.u-margin-bottom-4 {\n  margin-bottom: 4px;\n}\n\n.u-margin-bottom-8 {\n  margin-bottom: 8px;\n}\n\n.u-margin-bottom-16 {\n  margin-bottom: 16px;\n}\n\n.u-margin-bottom-24 {\n  margin-bottom: 24px;\n}\n\n.u-margin-bottom-32 {\n  margin-bottom: 32px;\n}\n\n.u-padding-y-16 {\n  padding: 16px 0;\n}\n\n.u-padding-x-16 {\n  padding: 0 16px;\n}\n\n.u-padding-16 {\n  padding: 16px;\n}\n\n.u-padding-top-32 {\n  padding-top: 32px;\n}\n\n.u-padding-top-24 {\n  padding-top: 24px;\n}\n\n.u-padding-x-24 {\n  padding: 0 24px\n}\n\n.u-font-size-8 {\n  font-size: 8px;\n}\n\n.u-font-size-12 {\n  font-size: 12px;\n}\n\n.u-font-size-14 {\n  font-size: 14px;\n}\n\n.u-font-size-16 {\n  font-size: 16px;\n}\n\n.u-font-size-20 {\n  font-size: 20px;\n}\n\n.u-font-size-24 {\n  font-size: 24px;\n}\n\n.u-font-size-32 {\n  font-size: 32px;\n}\n\n.u-opacity-0 {\n  opacity: 0;\n}\n\n.u-white-space-nowrap {\n  white-space: nowrap;\n}\n\n/* Font Colors */\n.u-color-white {\n  color: var(--white);\n}\n\n.u-color-black {\n  color: var(--black);\n}\n\n.u-color-green {\n  color: var(--green);\n}\n\n.u-color-red {\n  color: var(--red);\n}\n\n.u-color-light-grey {\n  color: var(--light-grey);\n}\n\n.u-color-dark-grey {\n  color: var(--dark-grey);\n}\n\n.u-color-offwhite {\n  color: var(--offwhite);\n}\n\n.u-fill-white {\n  fill: var(--white);\n}\n\n.u-fill-black {\n  fill: var(--black);\n}\n\n.u-fill-gold {\n  fill: var(--gold);\n}\n\n.u-background-none {\n  background: none;\n}\n\n.u-border-none {\n  border: none;\n}\n\n.h3 {\n  text-align: left;\n  margin-top: 0;\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 28px;\n  margin-bottom: 16px;\n}\n\n/* \n * Utility class to hide content visually while keeping it screen reader-accessible.\n * Source: https://www.scottohara.me/blog/2017/04/14/inclusively-hidden.html \n */\n\n .u-visually-hidden:not(:focus):not(:active) {\n  clip: rect(0 0 0 0); \n  clipPath: inset(100%); \n  height: 1px; \n  overflow: hidden; \n  position: absolute; \n  white-space: nowrap; \n  width: 1px; \n}\n\n/* Component Styles */\n.c-plain-link {\n  text-decoration: none;\n}\n\n.c-clamp {\n  -webkit-line-clamp: 25;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  overflow-wrap: break-word;\n  mask-image: linear-gradient(to bottom, black 90%, transparent 100%);\n}\n\n.c-swing {\n  animation: swing ease-in-out 1s 3.5 alternate;\n  transform-origin: center -20px;\n  box-shadow: 5px 5px 10px rgba(0,0,0,0.5);\n  border-radius: var(--border-radius);\n  position: relative;\n}\n\n.c-swing img {\n  border-radius: var(--border-radius);\n  border: 5px solid var(--gold);\n  display: block;\n  box-shadow: var(--shadow);\n}\n\n.c-swing:after{\n  content: '';\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  border: 1px solid var(--black);\n  top: -9px;\n  left: 43%;\n  z-index: 0;\n  border-bottom: none;\n  border-right: none;\n  transform: rotate(45deg);\n}\n\n.c-swing:before{\n  content: '';\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  top: -17px;\n  left: 47%;\n  z-index: 5;\n  border-radius: 50% 50%;\n  background: linear-gradient(90deg, rgba(204, 163, 79, 1) 0%, rgba(152, 117, 46, 1) 100%);\n}\n\n@keyframes swing {\n  0% { transform: rotate(3deg); }\n  100% { transform: rotate(-3deg); }\n}\n\n/* Alice Carousel */\n.c-slider .alice-carousel__prev-btn,\n.c-slider .alice-carousel__next-btn {\n  width: unset;\n  padding: unset;\n  position: absolute;\n  top: 45%;\n  box-shadow: var(--shadow);\n  background-color: var(--white);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.c-slider .alice-carousel__dots {\n  margin-top: 0;\n}\n\n.c-slider .alice-carousel__prev-btn-item,\n.c-slider .alice-carousel__next-btn-item {\n  color: black;\n}\n\n.c-container {\n  margin: 0 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
